
/**
 * 将文件上传到阿里云OSS上，并返回图片地址
 * @param Blob 选择的文件
 * @param name 上传的文件名称
 * @param dir 一般为时间戳，保证文件不重复
 */

export default function uploadBlobToOSS(Blob: Blob, name: string, dir?: string): Promise<any> {
  return new Promise((resolve) => {
    const ossSignServerAddress: string = 'https://api-upload.xiaomai5.com/xm/oss/web/token?bucket=image';

    const xhr: XMLHttpRequest = new XMLHttpRequest();
    xhr.open('GET', ossSignServerAddress, false);
    xhr.send();
    const signInfo: any = JSON.parse(xhr.responseText);
    const fd: FormData = new FormData();
    const status: number = 200;
    fd.append('Filename', name);
    fd.append('callback', signInfo.callback);
    fd.append('expire', signInfo.expire);
    fd.append('policy', signInfo.policy);
    fd.append('signature', signInfo.signature);
    fd.append('OSSAccessKeyId', signInfo.accessid);
    fd.append('success_action_status', status.toString());
    if (!dir) {
      dir = Blob.type == 'text/html' ? 'html/' : '';
    }
    fd.append('key', signInfo.dir + dir + name);
    fd.append('file', Blob);

    xhr.onreadystatechange = function () {
      if (xhr.readyState == 4 && xhr.status == 200) {
        const result: any = JSON.parse(xhr.responseText);
        result.url = result.url.replace(/http:/, 'https:');
        resolve(result.url);
      }
    }
    const tempHost = signInfo.host;
    xhr.open('POST', tempHost);
    xhr.send(fd);
  })
}